export default __webpack_public_path__ + "static/media/mi_luz.f7021493.png";